import React from 'react';

import ModaleDefaut from '@/components/ModaleDefaut/ModaleDefaut';
import { URLS } from '@/constants/urls';

import styles from './styles.module.css';

type ContentModalInformationProps = {
  isEmailModalOpen: boolean;
  isPhoneModalOpen: boolean;
  isAddressModalOpen: boolean;
  setIsEmailModalOpen: (value: boolean) => void;
  setIsPhoneModalOpen: (value: boolean) => void;
  setIsAddressModalOpen: (value: boolean) => void;
  userEmail?: string;
};

const ContentModalInformation: React.FC<ContentModalInformationProps> = ({
  isEmailModalOpen,
  isPhoneModalOpen,
  isAddressModalOpen,
  setIsEmailModalOpen,
  setIsPhoneModalOpen,
  setIsAddressModalOpen,
}) => {
  return (
    <>
      {isEmailModalOpen && (
        <ModaleDefaut
          title={<div className={styles.modalTitle}>Modification de mon email</div>}
          content={
            <div className={styles.textModal}>
              <div>
                <p>
                  Vous devez faire{' '}
                  <b>
                    <span className="bolder-text">une demande manuscrite datée et signée</span>
                  </b>{' '}
                  en précisant votre nouvel email.
                </p>
                <p>Cette demande doit être accompagnée d&apos;un justificatif d&apos;identité en cours de validité.</p>
              </div>
              <p>
                Ces documents doivent être envoyés à :{' '}
                <b>
                  <u>
                    <a href={`mailto:${URLS.MTP_EMAIL}`} style={{ color: 'black' }}>
                      placement@meilleurtaux.com.
                    </a>
                  </u>
                </b>
              </p>
            </div>
          }
          btnLabel="Fermer"
          btnVariant="primary"
          btnSize="large"
          size="large"
          mobileStyle="stick-to-bottom"
          onClickClose={() => setIsEmailModalOpen(false)}
          onClickBtn={() => setIsEmailModalOpen(false)}
        />
      )}

      {isPhoneModalOpen && (
        <ModaleDefaut
          title={<div className={styles.modalTitle}>Modification de mon numéro de téléphone</div>}
          content={
            <div className={styles.textModal}>
              <p>
                Vous devez faire <b>une demande manuscrite datée et signée</b> précisant le nouveau numéro de téléphone.
              </p>
              <p>
                Cette demande doit être accompagnée d&apos;un justificatif d&apos;identité en cours de validité ainsi
                qu&apos;une facture de téléphone datée de moins de trois mois.
              </p>
              <p>
                Ces documents doivent être envoyés à :{' '}
                <b>
                  <u>
                    <a href={`mailto:${URLS.MTP_EMAIL}`} style={{ color: 'black' }}>
                      placement@meilleurtaux.com.
                    </a>
                  </u>
                </b>
              </p>
            </div>
          }
          btnLabel="Fermer"
          btnVariant="primary"
          btnSize="large"
          size="large"
          mobileStyle="stick-to-bottom"
          onClickClose={() => setIsPhoneModalOpen(false)}
          onClickBtn={() => setIsPhoneModalOpen(false)}
        />
      )}

      {isAddressModalOpen && (
        <ModaleDefaut
          title={<div className={styles.modalTitle}>Modification de mon adresse postale</div>}
          content={
            <div className={styles.textModal}>
              <p>
                Vous devez <b>envoyer un justificatif de domicile</b> à votre nom, daté de moins de trois mois et le
                transmettre à l&apos;adresse mail{' '}
                <b>
                  <u>
                    <a href={`mailto:${URLS.MTP_EMAIL}`} style={{ color: 'black' }}>
                      placement@meilleurtaux.com
                    </a>
                  </u>
                </b>
              </p>
              <p>
                (En cas d&apos;hébergement chez un tiers, les documents exigés sont : justificatif de domicile de moins
                de trois mois du tiers, une attestation d&apos;hébergement manuscrite datée et signée, un justificatif
                d&apos;identité en cours de validité du tiers hébergeur).
              </p>
            </div>
          }
          btnLabel="Fermer"
          btnVariant="primary"
          btnSize="large"
          size="large"
          mobileStyle="stick-to-bottom"
          onClickClose={() => setIsAddressModalOpen(false)}
          onClickBtn={() => setIsAddressModalOpen(false)}
        />
      )}
    </>
  );
};

export default ContentModalInformation;
